import { VaroCategories } from 'shared/analytics/types/categories';
import { VaroEvent } from 'shared/analytics/types/events';

export interface AnalyticsEvent<TEventName extends string> extends VaroEvent {
  key: TEventName; // This will hold the human-readable string value
  properties: {
    category: VaroCategories;
  };
}

export function createBaseEventsMap<
  TEventName extends string,
  TKeys extends string = string,
>(
  eventKeysRecord: Record<TKeys, TEventName>,
  category: VaroCategories,
): Record<TKeys, AnalyticsEvent<TEventName>> {
  const eventEntries = Object.entries(eventKeysRecord) as [TKeys, TEventName][];

  return eventEntries.reduce(
    (accumulator, [key, value]) => {
      accumulator[key] = {
        key: value,
        properties: {
          category,
        },
      };
      return accumulator;
    },
    {} as Record<TKeys, AnalyticsEvent<TEventName>>,
  );
}
